import IJobSection from "../../interfaces/IJobSection";
import classnames from "classnames";
import { LogoHope } from "./logo-hope";
import { BoxHeader } from "./box-header";
import * as React from "react";
import { CheckedSpinner } from "./checked-spinner";
import { useResultsContext } from "../../context/results-context";
import { Section } from "./section";

export function SectionConservation({section}: {section: IJobSection}) {
  const {results} = useResultsContext();
  const conservationReport = results.hope?.conservationReport;
  return (
    <Section section={section} className="ll-break-inside-avoid" style={{marginTop: '1rem',}}>
      <LogoHope/>
      <BoxHeader section={section}/>
      {!conservationReport ? (
        <div className="ll-section-body ll-section-spinner">
          <CheckedSpinner withText={true} errTextBefore={'No response from the HOPE server.'}/>
        </div>
      ) : (
        <div className="ll-section-body" style={{ marginTop: '0.8rem', padding: '0 3rem' }}>
          {conservationReport.map((v, i) => <li key={i}>{v}</li>)}
        </div>
      )}
    </Section>
  )
}